<template>
<div>
		<section class="schedule">
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
							<p class="card-header-title">
								Schedule
							</p>
						</header>
						<div class="card-table">
							<div class="content">
								<div class="columns">
									<div class="column">
										<p>
											We recommend that all psychics keep their schedule updated. You can increase your business when your existing and new customers know when you will be available. This will also help customers when they request to be called back while you are unavailable. To learn more how to use the schedule click here
										</p>
									</div>
								</div>
								<div class="columns">
									<div class="column is-6 offset-6">
										<div class="field is-maxed">
											<label class="label" style="display: inline">My current local time: </label> {{ currentTime }}
										</div>
									</div>
								</div>
								<div v-for="(weekday, wd_idx) in weekdays" :key="wd_idx" class="columns schedule-day is-mobile">
									<div class="column is-10">
										<h4>{{ weekday }}</h4>
										<p v-for="(segment, idx) in scheduleDay(wd_idx+1)" :key="idx">
											<i class="fa fa-clock-o"></i> {{ formatTime(segment.from) }} to {{ formatTime(segment.to) }} <span><i class="fa fa-bolt"></i> {{ displayStatus(segment.status) }}</span>
										</p>
									</div>
									<div class="column is-2">
										<a @click="editSchedule(scheduleDay(wd_idx+1), wd_idx)" class="button is-small is-primary is-pulled-right"><i class="fa fa-pencil"></i></a>
									</div>
								</div>
								<div class="column is-2">
									<div class="control">
										<button class="button is-small is-link" @click="saveSchedule">Save Schedule</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<Modal v-if="editScheduleShown" @close="saveSegment">
			<span slot="title">EDIT SCHEDULE FOR {{ weekdays[selectedScheduleDay].toUpperCase() }}</span>
			<form slot="body">
				<div class="columns" v-for="(seg, idx) in selectedSchedule" :key="idx">
					<div class="column is-3">
							<div class="field is-grouped">
								<select :value="hourPart(fixDate(seg.from))" @change="updateHourSegment($event, 'from', idx)">
									<option value="01">1</option>
									<option value="02">2</option>
									<option value="03">3</option>
									<option value="04">4</option>
									<option value="05">5</option>
									<option value="06">6</option>
									<option value="07">7</option>
									<option value="08">8</option>
									<option value="09">9</option>
									<option value="10">10</option>
									<option value="11">11</option>
									<option value="12">12</option>
								</select>
								:
								<select :value="minutePart(fixDate(seg.from))" @change="updateMinSegment($event, 'from', idx)">
									<option>00</option>
									<option>15</option>
									<option>30</option>
									<option>45</option>
								</select>
								<select :value="aPart(fixDate(seg.from))" @change="updateASegment($event, 'from', idx)">
									<option>AM</option>
									<option>PM</option>
								</select>
							</div>
					</div>
					-
					<div class="column is-3">
							<div class="field is-grouped">
								<select :value="hourPart(fixDate(seg.to))" @change="updateHourSegment($event, 'to', idx)">
									<option value="01">1</option>
									<option value="02">2</option>
									<option value="03">3</option>
									<option value="04">4</option>
									<option value="05">5</option>
									<option value="06">6</option>
									<option value="07">7</option>
									<option value="08">8</option>
									<option value="09">9</option>
									<option value="10">10</option>
									<option value="11">11</option>
									<option value="12">12</option>
								</select>
								:
								<select :value="minutePart(fixDate(seg.to))" @change="updateMinSegment($event, 'to', idx)">
									<option>00</option>
									<option>15</option>
									<option>30</option>
									<option>45</option>
								</select>
								<select :value="aPart(fixDate(seg.to))" @change="updateASegment($event, 'to', idx)">
									<option>AM</option>
									<option>PM</option>
								</select>
							</div>
					</div>
					<div class="column is-5">
						<div class="field is-grouped">
							<div class="control is-expanded has-icons-left">
								<div class="select is-small">
									<select :value="seg.status" @change="updateSegStatus($event, idx)">
										<option value="A">Available</option>
										<option value="O">On Alert</option>
									</select>
									<span class="icon is-small is-left">
								<i class="fa fa-bolt"></i>
								</span>
								</div>
							</div>
							<div class="control add">
								<a class="button is-primary is-small" @click="deleteSegment(idx)">Delete</a>
							</div>
						</div>
					</div>
				</div>
				<div class="column"><div class="field"><div class="control"><a class="button is-primary is-small" @click="addSegment">+</a></div></div></div>
			</form>
		</Modal>
        </div>
</template>

<script>
	import Modal from "../Modal.vue"
    import moment from "moment-timezone"

	export default {
		components: {
			Modal,
        },	
        props: {
            id: String
        },
		data() {
			return {
				schedule: [],
				weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
				editScheduleShown: false,
				selectedSchedule: [],
				selectedScheduleDay: 0,
			}
		},
		methods: {
			saveSchedule() {
				this.$root.$data.setters.updateSchedule(this.$root.$data.state, this.id, this.schedule)
				this.$notify({
					group: 'global',
					type: 'success',
					title: 'Schedule Saved',
					text: 'Your schedule was saved',
				})
			},
			saveSegment() {
				let newSchedule = []
				this.schedule.forEach((ts) => {
					if (this.selectedScheduleDay+1 !== ts.day) {
						newSchedule.push(ts)
					}
				})

				for (let i = 0; i < this.selectedSchedule.length; i++) {
					newSchedule.push(this.selectedSchedule[i])
				}

				this.schedule = newSchedule.sort((a, b) => (a.day > b.day))
				this.editScheduleShown = false
				this.selectedSchedule = []
			},
			updateSegStatus(e, idx) {
				this.selectedSchedule[idx].status = e.target.value
			},
			updateHourSegment(e, orig, idx) {
				this.selectedSchedule[idx][orig] = moment.tz(`2001-01-02 ${e.target.value}:${this.minutePart(this.selectedSchedule[idx][orig])}:00 ${this.aPart(this.selectedSchedule[idx][orig])}`, "YYYY-MM-DD hh:mm:ss A", moment.tz.guess(true))
			},
			updateMinSegment(e, orig, idx) {
				this.selectedSchedule[idx][orig] = moment.tz(`2001-01-02 ${this.hourPart(this.selectedSchedule[idx][orig])}:${e.target.value}:00 ${this.aPart(this.selectedSchedule[idx][orig])}`, "YYYY-MM-DD hh:mm:ss A", moment.tz.guess(true))
			},
			updateASegment(e, orig, idx) {
				this.selectedSchedule[idx][orig] = moment.tz(`2001-01-02 ${this.hourPart(this.selectedSchedule[idx][orig])}:${this.minutePart(this.selectedSchedule[idx][orig])}:00 ${e.target.value}`, "YYYY-MM-DD hh:mm:ss A", moment.tz.guess(true))
			},
			deleteSegment(idx) {
				let newSchedule = []
				for(let i = 0; i < this.selectedSchedule.length; i++) {
					if (i !== idx) {
						newSchedule.push(this.selectedSchedule[i])
					}
				}

				for (let i = 0; i < newSchedule.length; i++) {
					newSchedule[i].number = i+1
				}

				this.selectedSchedule = newSchedule
			},
			addSegment() {
				const newSegment = {
						day: this.selectedScheduleDay + 1,
						number: this.selectedSchedule.length + 1,
						from: moment.tz(new Date("2001-01-02T00:00:00"), moment.tz.guess(true)),
						to: moment.tz(new Date("2001-01-02T00:00:00"), moment.tz.guess(true)),
						status: "A"
					}
				this.selectedSchedule.push(newSegment)

				for (let i = 0; i < this.selectedSchedule.length; i++) {
					this.selectedSchedule[i].number = i+1
				}
			},
			fixDate(date) {
				return moment.tz(date, moment.tz.guess(true))
			},
			hourPart(time) {
				return time.format("hh")
			},
			minutePart(time) {
				return time.format("mm")
			},
			aPart(time) {
				return time.format("A")
			},
			scheduleDay(day) {
				if (this.schedule.length > 0) {
					return this.schedule.filter((s) => {
						if (s.day === day) { return s }
					}).sort((a, b) => (a.number > b.number))
				}
			},
			displayStatus(s) {
				if (s === "A") { return "Available" }
				return "On Alert"
			},
			formatTime(date) {
				return moment.tz(date, moment.tz.guess(true)).format("hh:mm A")
			},
			editSchedule(schedule, day) {
				if (schedule === undefined) {
					this.selectedSchedule = []
				} else {
					this.selectedSchedule = schedule
				}
				this.selectedScheduleDay = day
				this.editScheduleShown = true
			}
		},
		computed: {
			currentTime() {
				return moment.tz(new Date, moment.tz.guess(true)).format("hh:mm:ss A")
			}
		},
		async created() {
			this.schedule = await this.$root.$data.getters.getSchedule(this.$root.$data.state, this.id)
		}
	}
</script>